export default __webpack_public_path__ + "static/media/morphys.944b480f.gif";